// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__Lp-v2","info":"UpdateTermsInfo_info__1Q433"};